import "@szhsin/react-menu/dist/index.css";
import "@szhsin/react-menu/dist/transitions/zoom.css";
import "./header.scss";

import { Link, NavLink } from "react-router-dom";
import "bootstrap/dist/js/bootstrap";
import {
  Menu,
  MenuItem,
  MenuButton,
  MenuDivider,
} from "@szhsin/react-menu";
import { _SIGNOUT } from "../models/common/cognito-signout";
import { useState } from "react";

interface MenuLandingProps{
  onSignIn: () => void;
}

export const MenuLandingComponent = ({ onSignIn }:MenuLandingProps) => {
  
  const [menuClass, setMenuClass] = useState<string>(
    "menu-button dropdown-toggle"
  );
  const [menuProfile, setMenuProfile]=useState<string>(
    "menu-staff"
  )
  const onRedirect=()=>{
      onSignIn();
  }
  return (
    <>
      <div className="justify-content-between">
        <button className={menuProfile} onClick={onRedirect} >Staff Login</button>
        <Menu menuButton={<MenuButton className={menuClass}>Agents</MenuButton>}>
          <MenuItem>
            <Link to="/Home" className="nav-link text-dark">
                Agent Login
            </Link>
          </MenuItem>
          <MenuItem>
            <Link to="/Home" className="nav-link text-dark">
                Download App
            </Link>
          </MenuItem>
        </Menu>
        <Menu
          menuButton={<MenuButton className={menuClass}>Products</MenuButton>}
        >
          <MenuItem>
            <Link to="/Category" className="nav-link text-dark">
              Milk 
            </Link>
          </MenuItem>
          <MenuDivider />
          <MenuItem>
            <Link to="/Category" className="nav-link text-dark">
              Products 
            </Link>
          </MenuItem>
       </Menu>
       <Menu menuButton={<MenuButton className={menuClass}>About Us</MenuButton>}>
          <MenuItem>
            <Link to="/Home" className="nav-link text-dark">
                Conatct us
            </Link>
          </MenuItem>
          <MenuItem>
            <Link to="/Home" className="nav-link text-dark">
                Location
            </Link>
          </MenuItem>
        </Menu>
   
      </div>
    </>
  );
};
